import { render, staticRenderFns } from "./AlsoExplore.vue?vue&type=template&id=87086f1c&"
import script from "./AlsoExplore.vue?vue&type=script&lang=js&"
export * from "./AlsoExplore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports